<template>
  <swiper
    :spaceBetween="25"
    :speed="15000"
    :loop="false"
    :autoplay="{
      delay: 1,
      disableOnInteraction: true,
      reverseDirection: true,
    }"
    :breakpoints="{
      0: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 4,
      },
    }"
    :modules="modules"
    class="brand-slider-two"
  >
    <swiper-slide v-for="logo in logos" :key="logo.id">
      <div class="brand-logo">
        <img :src="logo.image" alt="Image" class="d-block mx-auto" />
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default {
  name: "BrandLogoTwo",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      logos: [
        {
          id: 1,
          image: require("../../assets/img/home-one/brand/brand-7.webp"),
        },
        {
          id: 2,
          image: require("../../assets/img/home-one/brand/brand-8.webp"),
        },
        {
          id: 3,
          image: require("../../assets/img/home-one/brand/brand-9.webp"),
        },
        {
          id: 4,
          image: require("../../assets/img/home-one/brand/brand-10.webp"),
        },
        {
          id: 5,
          image: require("../../assets/img/home-one/brand/brand-1.webp"),
        },
        {
          id: 6,
          image: require("../../assets/img/home-one/brand/brand-2.webp"),
        },
        {
          id: 7,
          image: require("../../assets/img/home-one/brand/brand-3.webp"),
        },
        {
          id: 8,
          image: require("../../assets/img/home-one/brand/brand-4.webp"),
        },
        {
          id: 9,
          image: require("../../assets/img/home-one/brand/brand-5.webp"),
        },
        {
          id: 10,
          image: require("../../assets/img/home-one/brand/brand-6.webp"),
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>